var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvierte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.881,
    height: 63.881,
    viewBox: "0 0 63.881 63.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ab53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36953e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    transform: "translate(-137.959 -939.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    transform: "translate(137.959 939.871)",
    stroke: "#fff",
    strokeWidth: 3,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.94,
    cy: 31.94,
    r: 31.94,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.94,
    cy: 31.94,
    r: 30.44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "money_4_",
    "data-name": "money (4)",
    transform: "translate(155.885 956.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5107",
    "data-name": "Path 5107",
    d: "M192.153,182a10.153,10.153,0,1,0,10.153,10.153A10.165,10.165,0,0,0,192.153,182Zm0,9.23a2.762,2.762,0,0,1,.923,5.368v2.016H191.23V196.6a2.765,2.765,0,0,1-1.846-2.6h1.846a.923.923,0,1,0,.923-.923,2.762,2.762,0,0,1-.923-5.368v-2.016h1.846v2.016a2.765,2.765,0,0,1,1.846,2.6h-1.846a.923.923,0,1,0-.923.923Z",
    transform: "translate(-170.801 -170.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5108",
    "data-name": "Path 5108",
    d: "M10.276,11.2c5.693,0,10.153-2.433,10.153-5.538S15.97,0,10.276,0,0,2.556,0,5.661,4.583,11.2,10.276,11.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5109",
    "data-name": "Path 5109",
    d: "M0,337.559v1.5c0,3.105,4.583,5.538,10.276,5.538.323,0,.636-.03.954-.045a11.921,11.921,0,0,1-1.547-3.669C5.566,340.773,1.991,339.508,0,337.559Z",
    transform: "translate(0 -316.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5110",
    "data-name": "Path 5110",
    d: "M9.4,254.554c-.021-.29-.044-.58-.044-.876a11.947,11.947,0,0,1,.341-2.791c-4.122-.112-7.7-1.377-9.695-3.328v1.5C0,252,4.139,254.315,9.4,254.554Z",
    transform: "translate(0 -232.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5111",
    "data-name": "Path 5111",
    d: "M10.276,164.6h0a12.041,12.041,0,0,1,2.593-3.865,20.6,20.6,0,0,1-2.6.173c-4.382,0-8.189-1.307-10.276-3.35v1.5C0,162.168,4.583,164.6,10.276,164.6Z",
    transform: "translate(0 -147.863)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvierte);
export default __webpack_public_path__ + "static/media/invierte.bfc1a6534f37005440ebf2a9b84c0eb7.svg";
export { ForwardRef as ReactComponent };